import React from 'react';
import _ from 'lodash';
import { Alert } from 'reactstrap';
import bgLanding from 'assets/img/landing-bg.png';

function Landing({ session }) {
  const { id, groups = [] } = session || {};

  const showAlert = id && groups.length === 0;

  return (
    <div className="tw-max-w-6xl tw-mx-auto md:tw-pt-16">
      {showAlert && (
        <Alert color="info">
          <h4 className="tw-my-0 tw-mt-2">Thank you for the registration.</h4>
          <hr />
          <p className="tw-text-lg">We are reviewing your registration and assigning membership to your account.</p>
        </Alert>
      )}
      <div
        className="tw-text-left tw-text-white tw-w-full tw-h-full tw-bg-no-repeat tw-bg-cover tw-bg-[50%_0] tw-p-8"
        style={{ backgroundImage: `url(${bgLanding})` }}
      >
        <div className="tw-border-2 tw-border-solid tw-border-white tw-p-8">
          <div className="tw-font-bold tw-text-5xl tw-leading-normal">
            The Science and Art of
            <br />
            Managing Investment Portfolios
          </div>
          <hr className="tw-border-t-4 tw-border-solid tw-border-[#4682b4] tw-mt-2 tw-mb-8" />
          <div className="tw-font-semibold tw-text-2xl">Analytics. Intelligence. Insights. Outcomes.</div>
          <p className="tw-mt-14 tw-text-3xl tw-max-w-5xl">
            Revolutionizing due diligence and portfolio construction with cutting edge technology, analytics and data
            visualization.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Landing;
